module.exports = __webpack_public_path__ + "static/media/pitcairn-islands.32721be2.svg";